//@ts-check
import React from 'react';
import Formatter from '../../../formatter';
import ContactUtils from '../../../utils/contact';
var getPropVal = ContactUtils.getPropVal;
/**
 * @typedef {object} NameFormatterData
 * @property {string} Id
 *
 * @typedef {object} Props
 * @property {NameFormatterData} data
 *
 * @param {Props} props
 */

var NameFormatter = function NameFormatter(_ref) {
  var data = _ref.data;
  return React.createElement(Formatter.Link, {
    icon: "visitor",
    text: data.Id,
    value: "/EOS/People/#people/AnonymousUsers/".concat(data.Id)
  });
};
/**
 * @typedef {object} CommonProps
 * @property {object} data
 *
 * @param {CommonProps} props
 */


var StateFormatter = function StateFormatter(_ref2) {
  var data = _ref2.data;
  return React.createElement(Formatter.Text, {
    value: getPropVal(data, 'State')
  });
};
/** @param {CommonProps} props */


var CityFormatter = function CityFormatter(_ref3) {
  var data = _ref3.data;
  return React.createElement(Formatter.Text, {
    value: getPropVal(data, 'City')
  });
};
/** @param {CommonProps} props */


var CountryFormatter = function CountryFormatter(_ref4) {
  var data = _ref4.data;
  return React.createElement(Formatter.Text, {
    value: getPropVal(data, 'Country')
  });
};
/** @param {CommonProps} props */


var OSFormatter = function OSFormatter(_ref5) {
  var data = _ref5.data;
  return React.createElement(Formatter.Text, {
    value: getPropVal(data, 'OS')
  });
};
/** @param {CommonProps} props */


var BrowserFormatter = function BrowserFormatter(_ref6) {
  var data = _ref6.data;
  return React.createElement(Formatter.Text, {
    value: getPropVal(data, 'Browser')
  });
};
/** @param {CommonProps} props */


var DeviceFormatter = function DeviceFormatter(_ref7) {
  var data = _ref7.data;
  return React.createElement(Formatter.Text, {
    value: getPropVal(data, 'Device')
  });
};

var columns = [{
  id: 'State',
  formatter: StateFormatter
}, {
  id: 'City',
  formatter: CityFormatter
}, {
  id: 'Country',
  formatter: CountryFormatter
}, {
  id: 'OS',
  formatter: OSFormatter
}, {
  id: 'Browser',
  formatter: BrowserFormatter
}, {
  id: 'Device',
  formatter: DeviceFormatter
}];
var data = {
  url: '/backend/anonymousUsers',
  dataKey: 'anonymousUsers',
  idKeyProp: 'Id'
};
export default {
  columns: columns,
  data: data
};